import script from "./UserShiftsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UserShiftsTable.vue?vue&type=script&setup=true&lang=js"

import "./UserShiftsTable.vue?vue&type=style&index=0&id=350a3fe9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350a3fe9"]])

export default __exports__